import { render, staticRenderFns } from "./trimHandleLeft.vue?vue&type=template&id=5abb0725&"
import script from "./trimHandleLeft.vue?vue&type=script&lang=ts&"
export * from "./trimHandleLeft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports